import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Do I have to quit coffee?',
    a: "No. We simply adjust the timing and add a 'buffer' so it doesn't spike your nighttime cortisol."
  }, {
    q: 'How soon will I see results?',
    a: "Most users feel a physical 'lightness' and reduced anxiety within the first 48 hours."
  }, {
    q: 'Is this a workout?',
    a: 'No. These are gentle, somatic movements you can do in your pajamas.'
  }, {
    q: 'Is it a diet?',
    a: 'No. It is a targeted mineral protocol using basic kitchen ingredients.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream-200 py-24 px-6" data-id="element-13">
      <div className="container mx-auto max-w-3xl" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-15">
          <h2 className="font-serif text-4xl md:text-5xl text-navy-900 mb-6" data-id="element-16">
            Frequently Asked Questions
          </h2>
          <div className="w-16 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-17"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-cream-300 overflow-hidden" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-6 text-left flex justify-between items-center focus:outline-none" data-id="element-20">
                <span className="font-serif text-xl text-navy-800" data-id="element-21">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="text-gold-600 shrink-0 ml-4" data-id="element-22">
                  <ChevronDown size={24} data-id="element-23" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-24">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-25">
                    <div className="px-6 pb-6 pt-0 text-navy-700/80 text-lg font-light leading-relaxed border-t border-cream-100 mt-2 pt-4" data-id="element-26">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}